var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "rating-stars" },
    [
      _vm.dense
        ? _c("div", [_c("rating-star", { attrs: { value: 1 } })], 1)
        : _vm._l([1, 2, 3, 4, 5], function(i, index) {
            return _c("rating-star", {
              key: index,
              attrs: { value: Math.min(1, Math.max(0, _vm.value - i + 1)) }
            })
          })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-23d53014", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23d53014","hasScoped":true,"buble":{"objectAssign":"Object.assign","transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/Rating.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-23d53014","hasScoped":true,"buble":{"objectAssign":"Object.assign","transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/Rating.vue
// module chunks = 1 2 3